"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./AccordionBlock.scss");
var AccordionBlock = /** @class */ (function (_super) {
    __extends(AccordionBlock, _super);
    function AccordionBlock(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            var options = _this.props.options;
            var defaultExpanded = false;
            if (options && options.isOpen !== undefined) {
                defaultExpanded = options.isOpen;
            }
            else if (options && options.withExpand !== undefined) {
                defaultExpanded = options.withExpand;
            }
            _this.toggleOpen(defaultExpanded, true);
        };
        _this.componentDidUpdate = function (prevProps) {
            var options = _this.props.options;
            var openToResize = true;
            if (options && options.state && prevProps.options && prevProps.options.state) {
                var _a = options.state, isClosed = _a.isClosed, isOpen = _a.isOpen;
                if (prevProps.options.state.isOpen === false && isOpen === true) {
                    _this.toggleOpen(true, undefined);
                }
                else if (prevProps.options.state.isClosed === false && isClosed === true) {
                    _this.toggleOpen(false, undefined);
                    openToResize = false;
                }
            }
            if (openToResize && options && options.reSize === true) {
                _this.reSize();
            }
        };
        _this.onMouseDown = function (e) {
            if (e.button === 0) {
                var options = _this.props.options;
                if (options && options.state && options.setState) {
                    options.setState(__assign(__assign({}, options.state), { hideFocus: true }));
                }
                if (!options || !options.disabled) {
                    _this.toggleOpen(undefined, undefined);
                }
            }
        };
        _this.onKeyUp = function (e) {
            var keyCode = e.keyCode;
            var options = _this.props.options;
            if (options && options.state && options.setState) {
                options.setState(__assign(__assign({}, options.state), { hideFocus: false }));
            }
            if ((keyCode === 13 || keyCode === 32) && (!options || !options.disabled)) {
                _this.toggleOpen(undefined, undefined);
            }
        };
        _this.toggleOpen = function (isOpen, addTransition) {
            var uniqueId = _this.state.uniqueId;
            var el = document.getElementById(uniqueId);
            var _a = _this.props, events = _a.events, options = _a.options;
            if (el) {
                if (isOpen === false || (isOpen === undefined && el.style.maxHeight !== "0px")) {
                    if (isOpen === undefined &&
                        events &&
                        events.onToggle &&
                        options &&
                        options.index !== undefined) {
                        events.onToggle(false, options.index);
                    }
                    el.style.maxHeight = "0px";
                    _this.setState({ isOpen: false }, function () { return _this.setIsOpenArrProps(false); });
                }
                else {
                    if (isOpen === undefined &&
                        events &&
                        events.onToggle &&
                        options &&
                        options.index !== undefined) {
                        events.onToggle(true, options.index);
                    }
                    el.style.maxHeight = el.scrollHeight + "px";
                    _this.setState({ isOpen: true }, function () { return _this.setIsOpenArrProps(true); });
                }
            }
            if (addTransition !== undefined) {
                _this.setState({ addTransition: addTransition });
            }
        };
        _this.setIsOpenArrProps = function (value) {
            var options = _this.props.options;
            if (options &&
                options.index !== undefined &&
                options.state !== undefined &&
                options.setState !== undefined) {
                options.state.isOpenArr[options.index] = value;
                if (options.state.isOpenArr.indexOf(false) === -1 &&
                    options.state.isExpandAll === true) {
                    options.setState(__assign(__assign({}, options.state), { isClosed: false, isExpandAll: false, isOpen: true, isOpenArr: options.state.isOpenArr.slice() }));
                }
                else if (options.state.isOpenArr.indexOf(true) === -1 &&
                    options.state.isExpandAll === false) {
                    options.setState(__assign(__assign({}, options.state), { isClosed: true, isExpandAll: true, isOpen: false, isOpenArr: options.state.isOpenArr.slice() }));
                }
            }
        };
        _this.reSize = function () {
            var _a = _this.state, uniqueId = _a.uniqueId, isOpen = _a.isOpen;
            var el = document.getElementById(uniqueId);
            if (el && isOpen) {
                el.style.maxHeight = el.scrollHeight + "px";
            }
        };
        _this.render = function () {
            var _a = _this.props, data = _a.data, options = _a.options;
            var _b = _this.state, addTransition = _b.addTransition, isInitiallyOpen = _b.isInitiallyOpen, isOpen = _b.isOpen, uniqueId = _b.uniqueId;
            var pad = options && options.paddingType === "small" ? "sm" : "md";
            return (React.createElement("div", { className: styles.accordionBlock + " border-bottom border-light-gray overflow-hidden" },
                React.createElement("button", { "aria-controls": uniqueId, "aria-haspopup": "true", "aria-expanded": isOpen, className: "" + styles.accordionBlockInner + (options && options.state && options.state.hideFocus
                        ? ""
                        : " " + styles.accordionBlockInnerFocus) + " border-bottom border-light-gray flex flex-items-start justify-between no-border pad-l-none pad-r-none pad-b-" + pad + " pad-t-" + pad, onKeyUp: !(options === null || options === void 0 ? void 0 : options.noArrowDown) ? _this.onKeyUp : undefined, onMouseDown: !(options === null || options === void 0 ? void 0 : options.noArrowDown) ? _this.onMouseDown : undefined, style: { cursor: options && options.disabled ? "not-allowed" : (options === null || options === void 0 ? void 0 : options.noArrowDown) ? "auto" : "pointer" } },
                    React.createElement("span", { className: (options && options.disabled ? "color-ui-medium-gray" : "color-ui-black") + " text-left flex-1 font-medium mar-b-none " + (data.className ? data.className : "type-md") }, data.title),
                    !(options === null || options === void 0 ? void 0 : options.noArrowDown) && (React.createElement("i", { className: "icon-chevron mar-l-sm " + (isOpen ? "rotate270" : "rotate90") + " " + styles.accordionChevron }))),
                !(options === null || options === void 0 ? void 0 : options.noArrowDown) && (React.createElement("div", { "aria-hidden": !isOpen, className: "" + (addTransition ? styles.accordionBlockChildren + " height-full " : "") + (isOpen && !(options && options.disabled) ? "mar-b-md " : "") + (!isOpen
                        ? styles.accordionBlockChildrenDisabled + " "
                        : isInitiallyOpen
                            ? ""
                            : styles.accordionBlockChildrenEnabled + " ") + "text-left type-base", id: uniqueId, role: "region", style: { overflow: "hidden" } }, data.children))));
        };
        _this.state = {
            addTransition: false,
            isInitiallyOpen: props.options && props.options.state && props.options.state.isOpen ? true : false,
            isOpen: props.options && props.options.state && props.options.state.isOpen ? true : false,
            uniqueId: (props.testId ? props.testId : "") + "-" + (props.options && props.options.index ? props.options.index : ""),
        };
        return _this;
    }
    return AccordionBlock;
}(React.PureComponent));
exports.default = AccordionBlock;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Accordion/components/AccordionBlock/AccordionBlock.js
// module id = 1738
// module chunks = 8